const validation = (values) =>{

    let errors = {};

    if (!values.name){
        errors.name = "Full Name Required";
    }

    if (!values.email ){
        errors.email = "Email or Mobile Number is Required";
    }

    if(values.email){
        if(!/\S+@\S+\.\S+/.test(values.email)){
            errors.email = "email is Invalid";
        }
    }

    if(!values.message){
        errors.message = "Enter a Message first";
    }

    return errors;
}

export default validation